export const getPromoEndDate = (endDate, isSBOTD) => {
  if (!endDate) {
    return null;
  }
  if (isSBOTD) {
    // offset in milliseconds
    const tzoffset = (new Date()).getTimezoneOffset() * 60000;
    const currentTimeMinusOffset = Date.now() - tzoffset;
    const formattedDate = new Date(currentTimeMinusOffset);
    return (formattedDate).toISOString().split('T')[0];
  }
  // for SBOTW, return the day before the end date
  const proEndDate = new Date(endDate.concat(' 23:59:59'));
  proEndDate.setDate(proEndDate.getDate() - 1);
  return proEndDate.toISOString().split('T')[0];
};

export const getLogoSrc = (isSBOTD, isDailyDealsEnabled) => {
  if (isSBOTD) {
    return (isDailyDealsEnabled ? 'Value-Pricing-Daily-Deals' : 'sbotd-badge');
  }
  return 'sbotw-badge';
};